import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import styles from '../../BeneficiaryDisplayForm.scss'

class CompanyForm extends Component {
    static propTypes = {
      form: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleFocus: PropTypes.func.isRequired,
      handleValidation: PropTypes.func.isRequired,
      schema: PropTypes.object.isRequired,
    }

    render() {
      const {
        schema, form, handleChange, handleValidation, handleFocus,
      } = this.props
      return (
        <div className={styles.fieldset}>
          <li>
            <TextInput
              {...schema.companyName}
              error={form.companyName.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.companyName.value}
              valid={form.companyName.valid}
            />
          </li>
        </div>
      )
    }
}

export default CompanyForm



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/components/Beneficiary/CompanyForm.js